import { useFirebaseState } from "../fbase";

export function useAuthIsReady() {
  const fbState = useFirebaseState();
  // noinspection JSUnresolvedVariable
  return (
    fbState && !fbState.isInitializing && fbState.auth && fbState.auth.isLoaded
  );
}
